import {InputProps as StandardInputProps} from "@mui/material/Input/Input";
import {parseIntSafe} from "../../util/Formatters";
import {TextField} from "@mui/material";
import React, {useEffect, useState} from "react";

export interface SimpleNumberTextFieldProps {
    label?: string;
    value: number | undefined;

    type?: React.InputHTMLAttributes<unknown>['type'];

    onChange: (newValue: number | undefined) => void;

    className?: string;
    InputProps?: Partial<StandardInputProps>;
}

export const SimpleNumberTextField = ({
                                          label, value, onChange, type,
                                          className, InputProps
                                      }: SimpleNumberTextFieldProps) => {
    const [text, setText] = useState<string>();
    const [valid, setValid] = useState<boolean>(true);

    useEffect(() => {
        setText("" + value);
    }, [value]);

    function handleTextChange(newValue: string) {
        setText(newValue);
        const result = parseIntSafe(newValue);
        if (result !== undefined) {
            onChange(result);
            setValid(true);
        } else {
            setValid(false);
        }
    }

    return (
        <TextField className={"number-control " + className}
                   label={label}
                   value={text}
                   type={type ?? "number"}
                   color={valid ? undefined : "error"}
                   InputProps={InputProps}
                   onChange={e => handleTextChange(e.target.value)}/>
    );
}
